import { Database, FilePlus, FileText, FolderSearch, Pencil, Search, SquareTerminal, Wrench, Zap } from 'lucide-react';

function GithubIcon({ size, className }: { size?: number; className?: string }): React.ReactElement {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true" className={className}>
      <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12" />
    </svg>
  );
}

const BUILTIN_ICONS: Record<string, React.ComponentType<{ size?: number; className?: string }>> = {
  Read: FileText,
  Grep: Search,
  Glob: FolderSearch,
  Bash: SquareTerminal,
  Write: FilePlus,
  Edit: Pencil,
};

/** Shell MCP action → specific icon (instead of generic Box for all shell tools). */
const SHELL_ACTION_ICONS: Record<string, React.ComponentType<{ size?: number; className?: string }>> = {
  read: FileText,
  write: FilePlus,
  edit: Pencil,
  bash: SquareTerminal,
  grep: Search,
  glob: FolderSearch,
};

const CATEGORY_ICONS: Record<string, React.ComponentType<{ size?: number; className?: string }>> = {
  warehouse: Database,
  github: GithubIcon,
  rudderstack: Zap,
};

export function ToolIcon({ category, action }: { category: string; action: string }): React.ReactElement {
  if (category === 'builtin' && BUILTIN_ICONS[action]) {
    const Icon = BUILTIN_ICONS[action];
    return <Icon size={14} className="text-brand" data-testid={`icon-builtin-${action.toLowerCase()}`} />;
  }

  if (category === 'shell' && SHELL_ACTION_ICONS[action]) {
    const Icon = SHELL_ACTION_ICONS[action];
    return <Icon size={14} className="text-brand" data-testid={`icon-shell-${action}`} />;
  }

  const CategoryIcon = CATEGORY_ICONS[category];
  if (CategoryIcon) {
    return <CategoryIcon size={14} className="text-brand" data-testid={`icon-${category}`} />;
  }

  return <Wrench size={14} className="text-brand" data-testid="icon-unknown" />;
}
